import { useMemo } from 'react';
import { USDCRewardsEligibility, useUSDCRewards } from '@/hooks/useUSDCRewards';
import { messages } from '@/messages';
import { usePositions } from '@/onchain/hooks/usePositions';

export function useUSDCRewardsData() {
  const { positions } = usePositions();
  const usdcRewardsStatus = useUSDCRewards();

  const usdcPositions = useMemo(
    () => positions.filter((p) => p.positionTokens?.some((t) => t.symbol === 'USDC')),
    [positions],
  );

  const totalUsdcUsd = useMemo(
    () => usdcPositions.reduce((acc, p) => acc + (p.totalLiquidityNotional ?? 0), 0),
    [usdcPositions],
  );

  const usdcPoolsInvested = useMemo(() => {
    const ids = new Set<string>();
    usdcPositions.forEach((p) => {
      if (p.poolId) ids.add(p.poolId);
    });
    return ids.size;
  }, [usdcPositions]);

  const isInstitutional = usdcRewardsStatus === USDCRewardsEligibility.INSTO_USDC_REWARDS;
  const showRewardsCard = usdcRewardsStatus !== USDCRewardsEligibility.NA;
  const isEarning = usdcPoolsInvested > 0;

  const message = isInstitutional
    ? messages['usdcRewards.portfolio.institutional.card.message']
    : messages['usdcRewards.portfolio.retail.card.message'];

  const learnMoreUrl = isInstitutional
    ? messages['usdcRewards.portfolio.institutional.card.learnMoreUrl']
    : messages['usdcRewards.portfolio.retail.card.learnMoreUrl'];

  const learnMore = isInstitutional
    ? messages['usdcRewards.portfolio.institutional.card.learnMore']
    : messages['usdcRewards.portfolio.retail.card.learnMore'];

  return {
    totalUsdcUsd,
    usdcPoolsInvested,
    isInstitutional,
    showRewardsCard,
    isEarning,
    message,
    learnMoreUrl,
    learnMore,
  };
}
